export default __webpack_public_path__ + "static/media/MelindaMafnas.b87e2bfe.jpg";